import type { SVGProps } from 'react';

const SvgHeartOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2 8.5A5.5 5.5 0 0 1 7.5 3c1.805 0 3.265.776 4.221 1.807l.279.279.279-.28C13.235 3.777 14.695 3 16.5 3A5.5 5.5 0 0 1 22 8.5c0 1.085-.136 1.99-.527 2.851-.386.849-.984 1.574-1.766 2.356L13.414 20a2 2 0 0 1-2.828 0l-6.293-6.293c-.782-.782-1.38-1.507-1.766-2.356C2.136 10.491 2 9.585 2 8.5M7.5 5A3.5 3.5 0 0 0 4 8.5c0 .915.114 1.51.348 2.024.24.526.641 1.05 1.36 1.769L12 18.586l6.293-6.293c.718-.718 1.12-1.243 1.36-1.77.233-.513.347-1.108.347-2.023A3.5 3.5 0 0 0 16.5 5c-1.212 0-2.157.517-2.764 1.177l-.014.015L12 7.914l-1.722-1.722-.014-.015C9.657 5.517 8.712 5 7.5 5"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgHeartOutlined;
